var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", color: "green" },
          }),
          _vm._v(" "),
          _c("p", { staticClass: "mt-2" }, [
            _vm._v("データを読み込んでいます。しばらくお待ちください..."),
          ]),
        ],
        1
      )
    : _c("div", { staticClass: "bg-light" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "container my-4" }, [
          _c("div", { staticClass: "row justify-content-center" }, [
            _c("div", { staticClass: "col-12 col-md-10 col-lg-8" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "card mb-4" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("h2", { staticClass: "h6 fw-bold mb-4" }, [
                    _vm._v("変更内容のご確認"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bg-light p-4 rounded" }, [
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        { staticClass: "text-secondary small d-block mb-1" },
                        [_vm._v("変更前")]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          _vm._s(_vm.subscription.premiumServiceName) +
                            "（¥" +
                            _vm._s(
                              _vm.localNumber(
                                _vm.calcTaxIncluded(
                                  _vm.subscription &&
                                    _vm.subscription.premiumServicePrice
                                    ? _vm.subscription.premiumServicePrice
                                    : 0
                                )
                              )
                            ) +
                            "/月）"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "label",
                        { staticClass: "text-secondary small d-block mb-1" },
                        [_vm._v("変更後")]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          _vm._s(_vm.targetPremiumService.name) +
                            "（¥" +
                            _vm._s(
                              _vm.localNumber(_vm.targetPremiumService.price)
                            ) +
                            "/月）"
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column flex-sm-row justify-content-between gap-3",
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-light border order-2 order-sm-1",
                      attrs: { to: "/classroom" },
                    },
                    [_vm._v("\n            マイページへ戻る\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "btn btn-primary order-1 order-sm-2 text-white",
                      attrs: { to: "/classroom" },
                    },
                    [_vm._v("\n            学習を始める\n          ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "text-secondary small text-center mt-4" },
                [
                  _vm._v(
                    "\n          ご不明な点がございましたら、お気軽にお問い合わせください\n        "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "progress rounded-0" }, [
      _c("div", {
        staticClass: "progress-bar bg-primary",
        staticStyle: { width: "100%" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container mt-4" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-12 col-md-10 col-lg-8" }, [
          _c("div", { staticClass: "d-flex justify-content-between" }, [
            _c("div", { staticClass: "progress-step text-center" }, [
              _c("div", {
                staticClass: "step-circle step-circle-complete mx-auto",
              }),
              _vm._v(" "),
              _c("small", { staticClass: "d-block mt-2 text-primary" }, [
                _vm._v("プランの確認"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "progress-step text-center" }, [
              _c("div", {
                staticClass: "step-circle step-circle-complete mx-auto",
              }),
              _vm._v(" "),
              _c("small", { staticClass: "d-block mt-2 text-primary" }, [
                _vm._v("お支払い"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "progress-step text-center" }, [
              _c("div", {
                staticClass: "step-circle step-circle-complete mx-auto",
              }),
              _vm._v(" "),
              _c(
                "small",
                { staticClass: "d-block mt-2 progress-step-active" },
                [_vm._v("完了")]
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card mb-4 animate-fadeInUp" }, [
      _c("div", { staticClass: "card-body text-center py-5" }, [
        _c("div", { staticClass: "success-icon-bg mx-auto mb-4" }, [
          _c("div", { staticClass: "success-icon" }, [
            _c("i", { staticClass: "bi bi-check-lg" }),
          ]),
        ]),
        _vm._v(" "),
        _c("h2", { staticClass: "h4 fw-bold mb-3" }, [
          _vm._v("プラン変更が完了しました"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-secondary mb-0" }, [
          _vm._v("確認メールをお送りしました"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-secondary small" }, [
          _vm._v("メールが届かない場合はスパムフォルダをご確認ください"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center mb-4" }, [
      _c("i", { staticClass: "bi bi-arrow-down text-secondary" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card next-steps mb-4" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("h2", { staticClass: "h6 fw-bold mb-3" }, [_vm._v("次のステップ")]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-start mb-2" }, [
          _c("i", { staticClass: "bi bi-journal-text next-steps-icon me-3" }),
          _vm._v(" "),
          _c("p", { staticClass: "mb-0" }, [
            _vm._v("新しいコースが利用可能になりました"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-start" }, [
          _c("i", { staticClass: "bi bi-play-circle next-steps-icon me-3" }),
          _vm._v(" "),
          _c("p", { staticClass: "mb-0" }, [
            _vm._v("マイページから学習を開始できます"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }